var SegmentationRepresentations;
(function (SegmentationRepresentations) {
    SegmentationRepresentations["Labelmap"] = "LABELMAP";
    SegmentationRepresentations["Contour"] = "CONTOUR";
})(SegmentationRepresentations || (SegmentationRepresentations = {}));
export default SegmentationRepresentations;
//# sourceMappingURL=SegmentationRepresentations.js.map